module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/main_img_04-3-8afbb96bd97de94463c669c3e507ca20.png";